(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/tipsen-bet-button/assets/javascripts/tipsen-bet-button.js') >= 0) return;  svs.modules.push('/components/lb-ui/tipsen-bet-button/assets/javascripts/tipsen-bet-button.js');
"use strict";


const Outcome = svs.components.lbUi.outcome.Outcome;
const TipsenBetButton = _ref => {
  let _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? '' : _ref$ariaLabel,
    _ref$branding = _ref.branding,
    branding = _ref$branding === void 0 ? '' : _ref$branding,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    _ref$handleClick = _ref.handleClick,
    handleClick = _ref$handleClick === void 0 ? () => {} : _ref$handleClick,
    _ref$hasUSign = _ref.hasUSign,
    hasUSign = _ref$hasUSign === void 0 ? false : _ref$hasUSign,
    _ref$isCorrect = _ref.isCorrect,
    isCorrect = _ref$isCorrect === void 0 ? false : _ref$isCorrect,
    _ref$isClickable = _ref.isClickable,
    isClickable = _ref$isClickable === void 0 ? false : _ref$isClickable,
    _ref$isReduceFree = _ref.isReduceFree,
    isReduceFree = _ref$isReduceFree === void 0 ? false : _ref$isReduceFree,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$sign = _ref.sign,
    sign = _ref$sign === void 0 ? '' : _ref$sign;
  const buttonClassNames = ['pg_tipsen_bet_button'];
  if (className) {
    buttonClassNames.push(className);
  }
  return React.createElement("button", {
    "aria-label": ariaLabel,
    "aria-selected": isSelected,
    className: buttonClassNames.join(' '),
    "data-testid": dataTestId,
    disabled: !isClickable,
    onClick: handleClick,
    type: "button"
  }, React.createElement(Outcome, {
    branding: branding,
    hasUSign: hasUSign,
    isDisabled: !isClickable,
    isReduceFree: isReduceFree,
    isResult: isCorrect,
    isSelected: isSelected,
    sign: sign
  }));
};
setGlobal('svs.components.lbUi.tipsenBetButton.TipsenBetButton', TipsenBetButton);

 })(window);